export const mySkills = [
  "React",
  "React Context",
  "Error handling",
  "Next.js",
  "TanStack Query",
  "JS classes",
  "TypeScript",
  "REST API",
  "Git",
  // eslint-disable-next-line
  "JavaScript (ES6+)",
  "Material UI",
  "GitHub Pull Requests & Review",
  "Semantic & accessible HTML",
  "Jest",
  "Scrum",
  "CSS",
  "React Testing Library",
  "Markdown",
  "Tailwind CSS",
  "Redux (Toolkit)",
  "NestJS",
  "Zustand",
  "Redux-Saga",
  "Prisma",
  "React Router",
  "BEM convention",
  "Docker",
  "React Hooks",
  "Responsive Web Design",
  "PostgreSQL",
];

export const myFutureSkills = [
  "React Native",
  "Cypress",
  "GraphQL",
  "Storybook",
];
